export function get(key) {
    const storageStr = localStorage.getItem(key);
    if (!storageStr) {
        return null;
    }
    const item = JSON.parse(storageStr);
    const now = new Date();
    if (now.getTime() > item.expires) {
        localStorage.removeItem(key)
        return null;
    }
    return item.data;
}

export function set(key, value, expiresInSeconds) {
    const now = new Date();
    const storageData = {
        data: key,
        expires: now.getTime() + expiresInSeconds
    }
    window.localStorage.setItem(key, JSON.stringify(storageData));
}
